<template>
    <list-base-template
        :items='items'
        event='thread'
        :create='false'
        :errors='this.errors'
        v-on:paginate='getResults()'>

        <template v-slot:header>
            <h2 class="h4 p-2 m-0" >Filing Issues - {{ show_all ? "All" : "Mine" }} {{ show_pending ? " - Failed + Pending" : "" }} </h2>
            <div class="btn-filter-toggle">
                <!-- <button type="button" class="btn btn-link" v-on:click='showFilter'><img src="img/icon-search.svg">
                    <span class="sr-only">Search</span>
                </button> -->
            </div>
        </template>   

        <template v-slot:quick_filters>
            
        </template>

        <template v-slot:site_select>
            <template>
                <div class='d-flex flex-row-reverse align-items-center pb-1 justify-content-end'>
                    <div v-if='$root.provider.site.length > 1' class='d-flex align-items-baseline col-xl-12 col-lg-24 pr-1 pl-0 ml-auto'>
                        <label class="site-select-label pr-1 pl-2 m-0">{{ $t('translations.site')}}:</label>
                        <b-form-select v-on:change='changeSite()' v-model='site_id' size="sm" class='invisible-select pl-1'>
                            <option value=''>{{$t('translations.all')}}</option>
                            <option v-for='site in $root.provider.site' :key='site.id' :value='site.id'>{{site.name}}</option>
                        </b-form-select>
                    </div>
                     <button
                            type="button" 
                            class="ml-2 btn-sm btn-light btn-refresh" v-on:click='getResults()'>
                        <span class="sr-only">Refresh</span>
                    </button> 
                    <div>
                    <b-form-checkbox 
                            v-model="show_all" 
                            name="show_all" 
                            class='ml-2'
                            switch>
                            
                        {{ $t("translations.show_all") }}
                    </b-form-checkbox>                 
                    <b-form-checkbox 
                            v-model="show_pending" 
                            name="show_pending" 
                            class='ml-2'
                            switch>
                            
                        {{ $t("translations.show_pending") }}
                    </b-form-checkbox>                 
                    </div>
                </div>
            </template>
        </template>

        <template v-slot:filter>
            <list-filter 
                v-on:apply='getResults(1)' 
                :expanded='true' 
                :key='event' 
                ref="listFilter" 
                :modalid='modalid'></list-filter>
        </template>

        <template v-slot:current-filter>
            <div v-if='$refs.listFilter || user_filter || created_by_user_filter'>
                <p v-if='$refs.listFilter && $refs.listFilter.$refs.search.value' class='search-lozenge badge badge-primary badge-pill'>
                    {{$refs.listFilter.$refs.search.value}}
                    <a v-on:click.prevent='$refs.listFilter.$refs.search.value = ""; getResults(1);' href="#">&times;</a>
                </p>
                <template v-for='(filter, index) in $refs.listFilter.appliedFilters'>
                    <p :key='index' v-if='$refs.listFilter.filterHasValue(filter)' class='search-lozenge badge badge-primary badge-pill'>
                        {{$refs.listFilter.getFilterDefinition(filter)}}
                        <a v-on:click.prevent='$refs.listFilter.appliedFilters.length > 1 ? $refs.listFilter.removeFilterByIndex(index) : $refs.listFilter.clearFilters();$refs.listFilter.applyFilters()' href="#">&times;</a>
                    </p>
                </template>
                <p v-if='user_filter' class='search-lozenge badge badge-primary badge-pill'>
                    User: {{formatName(user_filter)}}
                    <a v-on:click.prevent='user_filter = null' href="#">&times;</a>
                </p>
                <p v-if='created_by_user_filter' class='search-lozenge badge badge-primary badge-pill'>
                    Created by: {{formatName(created_by_user_filter)}}
                    <a v-on:click.prevent='created_by_user_filter = null' href="#">&times;</a>
                </p>
                <div :key='tag.tag_id' v-for='(tag, index) in tag_filter' class='search-lozenge badge badge-primary badge-pill' :style="{'background-color': getTag(tag.tag_id).colour}">
                    <i :class='"pr-1 fa fa-lg fa-" + getTag(tag.tag_id).icon' /> {{ getTag(tag.tag_id).name }}
                    <a v-on:click.prevent='deleteTag(index)' href="#">&times;</a>
                </div>
            </div>
            
        </template>

        <!-- SLOT: LIST -->
        <template v-slot:list>
            <ul class='list list-thread'>
                <!-- MAIN RENDER LOOP FOR THE REQUESTS -->
                <template v-for="item in items.data">
                    
                        <router-link tag='li' :to='(subroute ? "/" + "filing-list" : "") + "/" + "thread-show/" + item.id + (is_archived(item) ? "/1" : "")' :key='item.id' :class='"list-thread_item"'>
                            
                            <!-- ID: {{item.id}}<br /> -->
                            <!-- @updatehere -->
                            <!-- <h2 class="h6">{{item.id}}</h2> -->
                            <span class="status status-primary"></span>


                            <div class='list-flags' :class="getPriorityClass(item)">
                                <span v-if='is_archived(item)' :title="$t('translations.archived')" v-html="$t('translations.archived')" class="icon icon-archived"></span>
                                <span v-else-if='is_closed(item)' :title="$t('translations.closed')" v-html="$t('translations.closed')" class="icon icon-closed"></span>
                                <template v-else>
                                    <span v-if='is_unassigned(item)' :title="$t('translations.new')" class="icon icon-unassigned"></span>
                                    <span v-if='is_assignedToMe(item)' :title='assignee_name(item)' v-html="$t('translations.mine')" class="icon icon-mine"> </span>
                                    <span v-else-if='is_assignedToMyGroups(item)' :title='assignee_name(item)' v-html="$t('translations.mine')" class="icon icon-my-group"> </span>
                                    <span v-else-if='is_assigned(item)' :title='assignee_name(item)' v-html="$t('translations.assigned')" class="icon icon-assigned"> </span>
                                </template>
                                <!-- <span v-if='new_message(item)' title='Unread messages' class="icon icon-unread"></span> -->
                                <template v-if='!is_archived(item)'>
                                    <span v-if='is_patient() && new_message(item)' :title="$t('translations.unread_messages')" class="icon icon-unread"></span>
                                    <template v-if='is_staff()'>
                                        <template v-if='has_unread_response(item)'>
                                            <span v-if='new_message(item)' :title="autobrand('translations.new_message_patient_unread')" class="icon icon-patient-unread-new">UN</span>
                                            <span v-else :title="autobrand('translations.patient_unread')" class="icon icon-patient-unread">U</span>
                                        </template>
                                        <template v-else-if='patient_read_all(item)'>
                                            <span v-if='new_message(item)' :title="autobrand('translations.new_message_patient_read_all')" class="icon icon-patient-read-new">RAN</span>
                                            <span v-else :title="autobrand('translations.patient_read_all')" class="icon icon-patient-read">RA</span>
                                        </template>
                                        <span v-else-if='new_message(item)' title='Unread messages' class="icon icon-unread"></span>

                                        <!-- <span v-if='staff_has_responded(item)' title='Patient has received a response' class="icon icon-staff-responded">R</span> -->
                                        <!-- <span v-else title='Patient has not received a response' class="icon icon-staff-not-responded">NR</span>-->
                                    </template>
                                </template>
                            </div>

                            <div class="d-flex flex-wrap thread-meta">
                                <template v-if='item.user'>
                                    <h2 class="h6 mr-1">{{formatSurname(item.user)}} <template v-if='item.user.gender || item.user.dob'>(<template v-if='item.user.gender'>{{item.user.gender.toUpperCase()}}</template><template v-if='item.user.gender && item.user.dob'>&nbsp;</template><template v-if='item.user.dob'>{{item.user.dob | getAge}}</template>)</template></h2>
                                </template>
                                <!-- <template v-else-if='reportError("Missing user in thread", item)'>
                                </template> -->
                                <!-- <template v-if='reportError("Testing", item)'>
                                </template> -->
                            </div>

                            <div v-if='item.created_by && item.created_by != item.user_id' class="d-flex align-items-start" style="padding-bottom: 5px;">
                                <p class="thread-createdby">
                                    {{ $t('translations.created_by')}}: {{formatSurname(item.created_by_user)}}
                                </p>
                            </div>
                        
                            
                            <p class="subject">{{(item.question_group && item.question_group.question_group_type_id == 1) ? $t('translations.qa_in_progress') : ""}} {{item.subject ? item.subject.substring(0,100) : "[" + $t('translations.no_subject') + "]"}}</p>

                            <span class="time-stamp" style='line-height: 1.2'>{{item.created_at| formatDateTime}}</span>

                            <div>
                                <template v-for='(tag) in getTags(item)'>
                                    <div :key='"t-" + tag.tag_id' v-if='getTag(tag.tag_id).name' class='search-lozenge-thin badge badge-primary badge-pill' :style="{'background-color': getTag(tag.tag_id).colour}">
                                        <i :class='"pr-1 fa fa-lg fa-" + getTag(tag.tag_id).icon' /> {{ getTag(tag.tag_id).name }}
                                    </div>
                                </template>
                            </div>        

                        </router-link>
                </template>
            </ul>
            <!-- <div v-if='environment_settings.MIX_ENABLE_ARCHIVE && !archive && quickFilters && items.next_page_url == null && (quickFilters["advanced"] == true || quickFilters["closed"] == true)' class="text-center">
                <button type='button' class='btn btn-primary' v-on:click='enableArchive()'>
                    {{ autobrand('translations.continue_search_in_archive') }}
                </button>
            </div> -->
        </template>

        <template v-slot:sort>
            <select v-model='sort' v-on:change='setSort' class="form-control-sm btn-sort__date small col">
                <option v-bind:value='{field: "created_at", dir: "asc"}'>{{$t('translations.oldest_on_top')}}</option>
                <option v-bind:value='{field: "created_at", dir: "desc"}'>{{$t('translations.newest_on_top')}}</option>
            </select>
        </template>

        <template v-slot:perpage>
            <div v-if='items.current_page' class="align-self-center mr-1">
                <b-form-select class="form-control w-auto per-page-select" v-model='per_page' v-on:change='changePerPage()'>
                    <!-- <option>2</option> -->
                    <option>10</option>
                    <option>20</option>
                    <option>50</option>
                </b-form-select>
            </div>
        </template>

        <template v-slot:selectedcontent>
            <router-view 
                v-on:reopen='getResults()' 
                v-on:delete='getResults()' 
                v-on:viewNext='viewNext()'
                v-on:copied-to-mrs='$router.push({path: "/filing-list"}); getResults()' 
                v-on:cleared='$router.push({path: "/filing-list"}); getResults()'
                ref='content2' 
                name='content2' 
                :key="$route.fullPath">
            </router-view>
        </template>
    </list-base-template>
</template>

<script>
	export default {
        extends: app.base.threadListNew,
		props: [
		],
		data: function() {
			return {
                modalid: "thread-filter-modal",
                event: "thread",
                model: "thread",
                title: "requests",
                path: 'threads',
                route: '/api/v1/threads',
                hasArchive: true,
                user_filter: null,
                created_by_user_filter: null,
                show_all: -1,
                show_pending: -1,
                tag_filter: [],
                tag: null,
                monitor_root_request_updates: false,
                update_on_settings_toggle: false,
            };
        },
        watch: {
            show_all(value) {
				this.setSetting("failed_filing_show_all", value);

                // This is a bit shonky. Prevents a doublel update whilst reading settings, but there must
                // be a nicer way to do that. Probably by not using a watch.
                if(this.update_on_settings_toggle) {
                    this.getResults(1);
                }
                else {
                    this.update_on_settings_toggle = true;
                }
            },
            show_pending(value) {
				this.setSetting("failed_filing_show_pending", value);

                // This is a bit shonky. Prevents a doublel update whilst reading settings, but there must
                // be a nicer way to do that. Probably by not using a watch.
                if(this.update_on_settings_toggle) {
                    this.getResults(1);
                }
            },
        },
        beforeDestroy() {
            this.removeGlobalListener("UpdateFiling", this.getResults);
            
        },
        mounted() {
            this.registerGlobalListener("UpdateFiling", this.getResults);
        },
        methods : {
            initSettings() {
                this._initSettings();
                this.update_on_settings_toggle = false;
                this.show_pending = this.getSetting("failed_filing_show_pending", false);
                this.show_all = this.getSetting("failed_filing_show_all", false);
            },
            initData() {
				this.setLoading(true);
                this.errors = [];

                if(this.$root.lookup.relatedData[this.route]) {
                    this.processRelatedData(this.$root.lookup.relatedData[this.route]);
                }
                else {
                    axios.get(this.route + '/relatedData').then((res) => {
                        this.$root.lookup.relatedData[this.route] = res.data;
                        this.processRelatedData(res.data);
                    }).catch(error => {
                        this.setLoading(false);
                        this.handleError(error, "load");
                    });
                }
            },
            getItemCount() {
                return "";
            },
            
            getResults(page, showLoading, prevent) {
                this.setLoading(true);
				
				if (typeof page !== 'undefined') {
					this.items.current_page = page;
				}

                var fields = [];

                // if(this.$refs.listFilter && this.$refs.listFilter.filterShown) {
                //     var singleFields = this.$refs.listFilter.appliedFilters.filter(obj => {
                //         return (obj.field == "id" /* || obj.field == "user.surname" || obj.field == "user.dob" */) && obj.value;
                //     });
                    
                //     if(singleFields.length) {
                //         fields = singleFields;
                //     }
                //     else {
                //         // if(this.site_id) {
                //         //     search = encodeURIComponent(JSON.stringify(this.$refs.listFilter.appliedFilters.concat([{"field":"site_id","type":"=","value":this.site_id}])));
                //         // }
                //         // else {
                //         fields = this.$refs.listFilter.appliedFilters;
                //         // }
                //     }
                // }
                // else {
                //     fields.push({"id":26,"field":"secondary_status","type":"=","value":["waiting","completed"],"title":"translations.include","dataType":"checkbox-list"});
                // }

                fields.push({"id":26,"field":"secondary_status","type":"=","value":["waiting","completed"],"title":"translations.include","dataType":"checkbox-list"});
                var filing = {
                    "field": "filing", "value": {
                        filing_status_id: [2],
                        mine: true
                    }
                };
                    
                if(this.show_all) {
                    filing.value.mine = false;
                }
                
                if(this.show_pending) {
                    filing.value.filing_status_id = [2, 3, 999];
                }
                
                
                fields.push(filing);

                var search = encodeURIComponent(JSON.stringify(fields));

                var params = {sort: this.sort};
                this.items.data = [];
                var filter = "";
                
                return axios.get(this.route + '?site_id=' + (this.site_id ? this.site_id : "") + '&search=' + search + '&filter=' + filter + '&page=' + this.items.current_page + '&p=' + this.per_page + (this.archive ? '&archive=1' : ''), {params: params}).then((res) => {
                    if(res.data.current_page > res.data.last_page && prevent !== true) {
                        console.log("Re-searching with page in range.");
                        this.items = {};
                        this.getResults(res.data.last_page, showLoading, true)
                    }
                    else {
                        this.setLoading(false);
                        this.items = res.data;
                    }
                    axios.get(this.$root.apiBase + '/filing/failedFilings').then((res) => {
                        this.$root.setFailedFilingCount(res.data);
                    });
                }).catch((error) => {
                    if(showLoading) {
                        this.setLoading(false);
                    }
                    this.handleError(error, "load");
                    //this.$router.push({path: "/" + this.event + "-list"});
                });
			},
            
			is_assigned(item) {
				if(item.thread_provider && (item.thread_provider.assigned_user_id || item.thread_provider.assigned_group_id)) {
					return true
				}
				return false;
			},
			is_unassigned(item) {
				if(item.thread_provider && (!item.thread_provider.assigned_user_id && !item.thread_provider.assigned_group_id)) {
					return true
				}
				return false;
			},
			is_assignedToMe(item) {
				if(item.thread_provider && item.thread_provider.assigned_user_id == this.$root.user.id) {
					return true
				}

				return false;
            },
            is_waiting(item) {
				if(item.thread_provider && item.thread_provider.waiting_until) {
					return true
				}

				return false;
            },
            is_assignedToMyGroups(item) {
				if(item.thread_provider && item.thread_provider.assigned_group_id) {
					//alert("item.thread_provider.assigned_group_id:" + item.thread_provider.assigned_group_id);
					var val = this.$root.user.user_group.filter(obj => {
						//alert("obj.user_group_id: " + obj.user_group_id);
						//console.log("Comparing: " + "item.thread_provider.assigned_group_id:" + item.thread_provider.assigned_group_id + " to " + "obj.user_group_id: " + obj.user_group_id);
						return item.thread_provider.assigned_group_id == obj.user_group_id;
					});
					return val.length;
				}
				return false;
            },
            is_archived(item) {
				if(item.archived) {
					return true
				}
				return false;
			},
			new_message(item) {
				if(this.is_patient() || this.is_assignedToMe(item) || this.is_assignedToMyGroups(item) || this.is_unassigned(item)) {
					if(!item.user_thread_read_status) {
						return true;
					}
					if(item.latest_message != null && typeof item.latest_message == "object" && item.latest_message.created_at > item.user_thread_read_status.read_at) {
						return true;
					}
				}
				return false;
			},

			is_closed(item) {
				if(item.closed_at) {
					return true
				}
				return false;
			},
			staff_has_responded(item) {
				if(item.latest_message_to_patient) {
					return true;
				}
				return false;
			},
			has_unread_response(item) {
                // if(item.id == 19921) {
                //     console.log(item.latest_unread_message_to_patient, !this.is_patient(item.created_by_user), item.latest_unread_message_to_creator);
                //     console.log(item.latest_unread_message_to_patient && (!this.is_patient(item.created_by_user) || item.latest_unread_message_to_creator));
                // }
                if(item.latest_unread_message_to_patient && (!this.is_patient(item.created_by_user) || item.latest_unread_message_to_creator)) {
					return true;
				}
				return false;
			},
			patient_read_all(item) {
				if(this.staff_has_responded(item) && !this.has_unread_response(item)) {
					return true;
				}
				return false;
			},
			assignee_name(item) {
				if(item.thread_provider && item.thread_provider.assigned_user) {
					return item.thread_provider.assigned_user.surname + ", " + item.thread_provider.assigned_user.forenames;
				}
				else if(item.thread_provider && item.thread_provider.assigned_group) {
					return item.thread_provider.assigned_group.name;
				}
				return this.$t('translations.unassigned');

			},
			updateMessage: function () {
				this.message = this.$t('translations.updated')
				console.log(this.$el.textContent) // => 'not updated'
				this.$nextTick(function () {
					console.log(this.$el.textContent) // => 'updated'
				})
			},
			getPriorityClass(item) {
				if(this.is_staff()) {
					switch(item.thread_provider.priority) {
						case -10: return "lower"; break;
						case 0: return "routine"; break;
						case 5: return "visit"; break;
						case 10: return "urgent"; break;
						case 20: return "emergency"; break;
					}
				}
            },
            userHasOther(user) {
                return this.$root.userHasOther[user.id];
            },
            createdByHasOther(created_by_user) {
                return this.$root.createdByHasOther[created_by_user.id];
            },
            // userHasOther(user) {
            //     return this.items.data.filter(obj => {return obj.user.id === user.id && obj.closed_at === null}).length;
            // },
            // createdByHasOther(created_by_user) {
            //     if(!this.is_patient(created_by_user)) {
            //         return false;
            //     }
            //     return this.items.data.filter(obj => {return obj.created_by_user.id == created_by_user.id && !obj.closed_at}).length;
            // },
            // userHasOther(user) {
            //     var length = 0;
            //     for(var index = 0; index < this.items.data.length; index++) {
            //         if(this.items.data[index].user.id == user.id && !this.items.data[index].closed_at) {
            //             length++;
            //         }
            //     }
            //     return length;
            // },
            // createdByHasOther(created_by_user) {
            //     if(!this.is_patient(created_by_user)) {
            //         return false;
            //     }
            //     var length = 0;
            //     for(var index = 0; index < this.items.data.length; index++) {
            //         if(this.items.data[index].created_by_user.id == created_by_user.id && !this.items.data[index].closed_at) {
            //             length++;
            //         }
            //     }
            //     return length;
            // },
            getTags(item) {
                if(item.thread_tag || (item.user && item.user.user_tag)) {
                    var thread_tag = item.thread_tag ? item.thread_tag : [];
                    var user_tag = (item.user && item.user.user_tag) ? item.user.user_tag : [];
                    
                    return [...new Map(thread_tag.concat(user_tag).map(obj => [obj["tag_id"], obj])).values()];
                }
                
            },
            setDisplayValue() {
                Vue.nextTick(() => {
                    if(this.$refs.ac.value) {
                        var tag = this.$root.lookup.tags.find(obj => {return obj.id == this.$refs.ac.value});
                        if(tag) {
                            this.addTag();
                        }
                    }
                });
            },
            addTag(tag) {
                if(!this.tag_filter.find(obj => {return obj.tag_id == this.tag})) {
                    this.tag_filter.push({tag_id: this.tag});
                }
                this.tag = null;
                this.$refs.ac.clear();
                
            },
            deleteTag(index) {
                this.tag_filter.splice(index, 1); 
            }
            
		}
    }
</script>
